<template>
	<div>
		<div class="center" style="">

			<!-- side menu key -->
			<div v-if="this.sideMenuKey">
				<div v-if="this.debug" class="debug" style="margin-bottom:10px;"> {{ this.sideMenuKey }} </div>
				<SideMenuCategoryList v-if="this.sideMenuKey == 'category'"
					@sideMenuVisible="((visible) => this.sideMenuVisible(visible))" />

			</div>

			<!-- menu via route -->
			<div v-else-if="this.$route?.name?.toLowerCase() == 'products' ">
				<SideMenuProducts />
			</div>



			<div v-else>
				<SideMenuStart />
			</div>


		</div>
	</div>
</template>
<script>
import { STORE_GETTER } from '../../store/store';
import SideMenuCategoryList from './SideMenuCategoryList.vue';
import SideMenuProducts from './SideMenuProducts.vue';
import SideMenuStart from './SideMenuStart.vue';


//import { PRODUCT_STORE_ACTION } from '@/store/product-store';
//import EntityHeaderSort from "@/components/entity/EntityHeaderSort.vue";
//import listHelper from "@/helper/list-helper.js";
//import { logMixin } from "@/mixins/logMixin.js";

export default {
	name: "SideMenu",
	components: { SideMenuCategoryList, SideMenuStart, SideMenuProducts },
	mixins: [],
	props: {

	},
	data() {
		return {

		};
	},
	computed: {


		showProductFilter(){
			return this.$route?.name?.toLowerCase() == "products";
		},

		sideMenuKey(){
			return this.$store.getters[STORE_GETTER.SIDE_MENU_KEY]
		},

		defaultMenu(){

			return this.sideMenuKey == null && !this.showProductFilter
		},

		get() {
			//return this.$store.state.productStore.data.productList.filter(product => product !== null);
			//return this.$store.getters[STORE_GETTER.UNREAD_ERROR_MESSAGE]
			return 1

		}

		//baseModel() {
		//	return this.$store.getters[STORE_GETTER.BASE_MODEL]
		//},


	},
	watch: {
		//filterInput: function (filter) {
		//	console.log("FP: watcher: ", filter);
		//}

		//"product.name": {
		//	handler() {
		//		this.product.meta.state = settings.STATE_UPDATED
		//	}, deep: true
		//},
	},
	methods: {
		// this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, false);
		//this.$store.dispatch({ type: PRODUCT_STORE_ACTION.GET_PRODUCT_LIST, data: { loginToken: this.$store.state.loginToken } });
		sideMenuVisible(visible){
			this.$emit("sideMenuVisible", visible);
		}

	},

};
</script>

<style scoped>
html body div#app div.site.logout div div#sideMenu.open div div div div.center {
	margin-top: 20px;
}

html body div#app div.site.login div div#sideMenu.open div div div div.center{
	margin-top:80px;
}
</style>